import {
  FETCH_FRIENDS,
  FETCH_MORE_FRIENDS,
  FETCH_FRIEND_REQUESTS,
  ACCEPT_FRIEND_REQUEST,
  INITIATE_UNFRIEND_CONFIRMATION,
  CANCEL_UNFRIEND_CONFIRMATION,
  REMOVE_OR_DENY_FRIEND,
  FIND_FRIENDS,
  FETCH_PENDING_FRIEND_REQUESTS,
  ADD_FRIEND,
  FETCH_SUGGESTED_FRIENDS,
  FETCH_MORE_SUGGESTED_FRIENDS,
  SEARCH_USERS,
  RESET_FRIEND_API_OFFSETS,
  INVITE_FB_FRIENDS,
} from './constants'

export function getFriends (userId, limit = 40) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_FRIENDS,
      payload: mapmy.getFriends(userId, 0, limit),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getMoreFriends () {
  return (dispatch, getState, { mapmy }) => {
    const nextLink = getState().friends.myFriendsNextLink

    return dispatch({
      type: FETCH_MORE_FRIENDS,
      payload: mapmy.getNextLink(nextLink),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getFriendRequests (userId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_FRIEND_REQUESTS,
      payload: mapmy.getFriendRequests(userId),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function initiateUnfriend (userToUnfriend, isDenyingFriendRequest) {
  return (dispatch) => {
    return dispatch({
      type: INITIATE_UNFRIEND_CONFIRMATION,
      userToUnfriend: userToUnfriend,
      isDenyingFriendRequest: isDenyingFriendRequest,
    })
  }
}

export function cancelUnfriend () {
  return (dispatch) => {
    return dispatch({
      type: CANCEL_UNFRIEND_CONFIRMATION,
    })
  }
}

export function removeOrDenyFriend (userId, userToUnfriendId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: REMOVE_OR_DENY_FRIEND,
      payload: mapmy.removeFriend(userId, userToUnfriendId),
      meta: {
        userIdToRemove: userToUnfriendId,
        cancelledFriendRequestId: userId,
        globalErrorNotification: true,
      },
    })
  }
}

export function acceptFriendRequest (userId, userToAccept) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: ACCEPT_FRIEND_REQUEST,
      payload: mapmy.acceptFriend(userId, userToAccept.id),
      meta: {
        newFriend: userToAccept,
        globalErrorNotification: true,
      },
    })
  }
}

export function getPendingFriendRequests (userId) {
  return (dispatch, getState, { mapmy }) => {
    const promise = Promise.resolve()
      .then(() => {
        return mapmy.getPendingFriendRequests(userId)
      })
      .then((res) => {
        const pendingFriendIds = res.data._embedded.friendships.map((friend) => friend._links.to_user[0].id)
        const searchString = pendingFriendIds.toString()

        if (pendingFriendIds.length) {
          return mapmy.getBatchOfUsers(searchString)
        }

        // If the user has no pending requests, return a 'fake' empty response
        return Promise.resolve({
          data: {
            _embedded: {
              user: [],
            },
          },
        })
      })

    return dispatch({
      type: FETCH_PENDING_FRIEND_REQUESTS,
      payload: promise,
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function addFriend (friend, userId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: ADD_FRIEND,
      payload: mapmy.addFriend(friend.id, userId),
      meta: {
        friend: friend,
        globalErrorNotification: true,
      },
    })
  }
}

export function getSuggestedFriends (userId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_SUGGESTED_FRIENDS,
      payload: mapmy.getSuggestedFriends(userId),
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function getMoreSuggestedFriends (userId) {
  return (dispatch, getState, { mapmy }) => {
    const FRIEND_LIMIT_PER_REQUEST = 10
    const newOffset = getState().friends.mySuggestedFriendsOffset + 1
    const computedOffset = FRIEND_LIMIT_PER_REQUEST * newOffset + 1

    return dispatch({
      type: FETCH_MORE_SUGGESTED_FRIENDS,
      payload: mapmy.getSuggestedFriends(userId, computedOffset),
      meta: {
        newOffset: newOffset,
        globalErrorNotification: true,
      },
    })
  }
}

export function getFindFriendsData (userId) {
  return (dispatch) => {
    const promise = Promise.resolve()
      .then(() => Promise.all([
        dispatch(getPendingFriendRequests(userId)),
        dispatch(getSuggestedFriends(userId)),
      ]))

    return dispatch({
      type: FIND_FRIENDS,
      payload: promise,
      meta: {
        globalErrorNotification: true,
      },
    })
  }
}

export function searchUsers (searchTerm, userId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: SEARCH_USERS,
      payload: mapmy.searchUsers(searchTerm),
      meta: {
        currentUserId: userId,
        globalErrorNotification: true,
      },
    })
  }
}

export function resetFriendApiOffsets () {
  return (dispatch) => {
    return dispatch({
      type: RESET_FRIEND_API_OFFSETS,
    })
  }
}

export function inviteFacebookFriends (signUpUrl) {
  const params = {
    method: 'feed',
    link: signUpUrl,
    display: 'iframe',
  }
  return (dispatch, getState, { fb }) => {
    return dispatch({
      type: INVITE_FB_FRIENDS,
      payload: fb.postToFacebook(params),
    })
  }
}
